import { render, staticRenderFns } from "./CourseCodelyAssignmentView.vue?vue&type=template&id=5bb3b6cd&scoped=true"
import script from "./CourseCodelyAssignmentView.vue?vue&type=script&lang=js"
export * from "./CourseCodelyAssignmentView.vue?vue&type=script&lang=js"
import style0 from "./CourseCodelyAssignmentView.vue?vue&type=style&index=0&id=5bb3b6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3b6cd",
  null
  
)

export default component.exports